export default {
  PAYMENT_API_URL: 'https://pp-payment.circlechess.com',
  CHAT_API_URL: 'http://localhost:8001',
  ANALYZE_GAME_API_URL:
    'https://pp-api.circlechess.com/game/start_analyzing_game',
  // CHESS_API_URL: 'https://stg.circlechess.com',
  CHESS_API_URL: 'http://localhost:8000',
  DEBUG_ENABLED: true,
  // Faro disabled locally.
  FARO_URL: '',
  PLAYER_PROFILE_ENABLED: true,
  PLAY_V2_COHORT: 'flag',
  // HTTP_API_KEY: '3c311b2d-f168-47c2-9d2a-de5c2df8677a',
  API_KEY: '3c311b2d-f168-47c2-9d2a-de5c2df8677a',
  GAME_SERVICE_URL: 'wss://pp-gs.circlechess.com',
  X_API_KEY: '3c311b2d-f168-47c2-9d2a-de5c2df8677a',
  CAISSA_CHATBOT_API: 'https://65.1.214.145',
  TOURNAMENT_API_URL: 'https://pp-event-api.circlechess.com/api',
  //For Superset //staging server
  SUPERSET_URL: 'https://pp-superset.circlechess.com', //'http://35.154.36.228:8090',
  SUPERSET_USERNAME: 'admin',
  SUPERSET_PASSWORD: 'ccadmin',
  // Zoom
  ZOOM_IFRAME_BASE_URL: 'http://localhost:8080/zoom',
  ZOOM_IFRAME_BASE_EXIT_URL: 'http://localhost:8080/zoom',
  ZOOM_CLIENT_ID: 'vQmoHYNFQY6RzjczanVLFA',
  LICHESS_EXPLORER_TOKEN: 'lip_ER7vmduwNzHkFfl1TJh2',
  PUZZLE_ENC_KEY: 'f29fc7b0eaa2e1f935988a662fedc82d',

  // study
  EXPLORER_MASTERS_BASE_URL: 'https://opening-explorer-nonprod.circlechess.cc/masters',
  TABLEBASE_BASE_URL: 'https://tablebase-nonprod.circlechess.cc',

  // WAF_CHALLENGE_SCRIPT_URL: 'https://68ed58a14954.ap-south-1.captcha-sdk.awswaf.com/68ed58a14954/jsapi.js', // replaced by Turnstile
  // Cloudflare test site key — always passes locally (matches TURNSTILE_SECRET_KEY=1x0000000000000000000000000000000AA in chatbot .env)
  TURNSTILE_SITE_KEY: '1x00000000000000000000AA',
};
